import { Modal } from 'almanac-ui/Modal'
import Styles from './PostPreviewModal.module.scss'
import { DesignChannel } from 'components/NewFileModal/Types'
import { NoIntegration } from './NoIntegration'
import { IntegrationActions } from './IntegrationActions'
import { Skeleton } from 'antd'
import { PostPreviewProps, PostOptionsPage } from './Types'
import cx from 'classnames'
import { StalePreviewOverlay } from './components/StalePreviewOverlay'
import { Preview } from './Preview'
import { PostPreviewProvider, usePostPreviewContext } from './PostPreviewContext'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { PostPreviewModalV2 } from 'components/PostPreviewModalV2/PostPreviewModalV2'

const PostPreviewModal = ({
  fileId,
  channel,
  pollPreviewContentStream = true,
  showSuccessToast = true,
}: PostPreviewProps) => {
  const { page, scheduledPost, isLoading, provider, providerName, hasIntegration, previewIsStale } =
    usePostPreviewContext()

  const title = () => {
    switch (page) {
      case PostOptionsPage.PostDetails:
        return 'Post Now'
      case PostOptionsPage.Schedule:
        return 'Edit scheduled post'
      case PostOptionsPage.Reminder:
        return 'Set a reminder to post'
      default:
        return 'Post Now'
    }
  }

  if (!provider || !providerName) return null

  return (
    <Modal.Root size="md">
      <Modal.Header title={title()} />
      <div className={Styles.body}>
        <div className={Styles.preview}>
          <Preview
            channel={channel}
            loading={isLoading}
            post={scheduledPost}
            integration={scheduledPost?.external_integration}
            pollPreviewContentStream={pollPreviewContentStream}
          />
          {previewIsStale && <StalePreviewOverlay />}
        </div>
        {isLoading || !scheduledPost ? (
          <div className={cx(Styles.actionButtons, Styles.skeletonsContainer)} data-testid="skeleton">
            <Skeleton active />
            <Skeleton active />
          </div>
        ) : (
          <div className={Styles.actionButtons}>
            {hasIntegration && scheduledPost ? (
              <IntegrationActions fileId={fileId} channel={channel as DesignChannel} />
            ) : (
              <NoIntegration provider={provider} providerName={providerName} fileId={fileId} />
            )}
          </div>
        )}
      </div>
    </Modal.Root>
  )
}

const PostPreviewModalContainer = (props: PostPreviewProps) => {
  const isPostPreviewV2 = useFlipperFlag('post_preview_v2')

  const Component = isPostPreviewV2 ? PostPreviewModalV2 : PostPreviewModal

  return (
    <PostPreviewProvider {...props}>
      <Component {...props} isExistingFile />
    </PostPreviewProvider>
  )
}

export { PostPreviewModalContainer as PostPreviewModal }
